import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';


import TextDate from "components/text/TextDate";
import TextAmount from 'components/text/TextAmount';


const StatusList = ({ data }) => {

    const [showDetail, setShowDetail] = useState(false); 

    let result = data;
    return (
        <div className="calc-setting-table">
        <table className="table">
            <colgroup>
            <col />
            <col />
            <col />
            </colgroup>
            <thead>
            <tr>
            <th colSpan="3" className="text-left"><span className="calc-setting-table-header">Niðurstaða&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <input id="checkid1" type="checkbox" checked={showDetail} onChange={() => setShowDetail(!showDetail)}/><label className="calc-small-checkbox-label" htmlFor="checkid1" >Sýna niðurbrot</label>
            </th>

            </tr>
            <tr>
            <th className="text-left">Liður</th>
            <th className="text-right">Reiknað til <TextDate value={result.calculateTo}/> </th>
            <th className="text-right">Eftirstöðvar</th>
            </tr>
            </thead>
            <tbody>
            <tr>
            <th className="text-left">Höfuðstóll</th>
            <td className="text-right"><TextAmount value={result.currentSum.principal}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.principal}/></td>
            </tr>
            <tr>
            <th className="text-left">Samningsvextir</th>
            <td className="text-right"><TextAmount value={result.currentSum.contractInterests}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.contractInterests}/></td>
            </tr>
            <tr>
            <th className="text-left">Bankakostnaður</th>
            <td className="text-right"><TextAmount value={result.currentSum.bankCost}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.bankCost}/></td>
            </tr>
            <tr>
            <th className="text-left">Dráttarvextir</th>
            <td className="text-right"><TextAmount value={result.currentSum.penaltyInterests}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.penaltyInterests}/></td>
            </tr>
            <tr>
            <th className="text-left">Kostnaður kröfuhafa</th>
            <td className="text-right"><TextAmount value={result.currentSum.creditorCost}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.creditorCost}/></td>
            </tr>
            <tr>
            <th className="text-left">Áfallinn kostnaður</th>
            <td className="text-right"><TextAmount value={result.currentSum.accruedExpense}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.accruedExpense}/></td>
            </tr>
            {showDetail &&
            <tr className="status-calc-sub">
            <th className="text-left">-Áfallinn kostnaður sem ber VSK</th>
            <td className="text-right"><TextAmount value={result.currentSum.accruedExpenseCarryVat}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.accruedExpenseCarryVat}/></td>
            </tr>}
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Áfallinn kostnaður sem ber ekki VSK</th>
            <td className="text-right"><TextAmount value={result.currentSum.accruedExpenseDoesNotCarryVat}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.accruedExpenseDoesNotCarryVat}/></td>
            </tr>}
            <tr>
            <th className="text-left">Útlagður kostnaður</th>
            <td className="text-right"><TextAmount value={result.currentSum.outlaidExpense}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.outlaidExpense}/></td>
            </tr>
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Útlagður kostnaður sem ber VSK</th>
            <td className="text-right"><TextAmount value={result.currentSum.outlaidExpenseCarryVat}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.outlaidExpenseCarryVat}/></td>
            </tr>}
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Útlagður kostnaður sem ber ekki VSK</th>
            <td className="text-right"><TextAmount value={result.currentSum.outlaidExpenseDoesNotCarryVat}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.outlaidExpenseDoesNotCarryVat}/></td>
            </tr>}
            <tr>
            <th className="text-left">Vextir af kostnaði</th>
            <td className="text-right"><TextAmount value={result.currentSum.totalCostPenaltyInterests}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.totalCostPenaltyInterests}/></td>
            </tr>
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Vextir af áföllnum kostnaði</th>
            <td className="text-right"><TextAmount value={result.currentSum.accruedPenaltyInterests}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.accruedPenaltyInterests}/></td>
            </tr>}
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Vextir af útlögðum kostnaði</th>
            <td className="text-right"><TextAmount value={result.currentSum.outlaidPenaltyInterests}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.outlaidPenaltyInterests}/></td>
            </tr>}
            <tr>
            <th className="text-left">Virðisaukaskattur</th>
            <td className="text-right"><TextAmount value={result.currentSum.totalVat}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.totalVat}/></td>
            </tr>
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Virðisaukaskattur af áföllnum kostnaði</th>
            <td className="text-right"><TextAmount value={result.currentSum.accruedExpenseVat}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.accruedExpenseVat}/></td>
            </tr>}
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Virðisaukaskattur af útlögðum kostnaði</th>
            <td className="text-right"><TextAmount value={result.currentSum.outlaidExpenseVat}/></td>
            <td className="text-right"><TextAmount value={result.remainderSum.outlaidExpenseVat}/></td>
            </tr>}
            <tr>
            <th className="text-left">Afsláttur / niðurfelling</th>
            <td className="text-right"><TextAmount value={result.currentSum.discountsAndTerminations}/></td>
            <td className="text-right">&nbsp;</td>
            </tr>
            {showDetail &&  <tr className="status-calc-sub">
            <th className="text-left">-Afsláttur / niðurfelling kröfuhafi</th>
            <td className="text-right"><TextAmount value={result.currentSum.discountsAndTerminiationsCreditor}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>}
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Afsláttur / niðurfelling lögmaður</th>
            <td className="text-right"><TextAmount value={result.currentSum.discountAndTerminationsLawyer}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>}
            <tr>
            <th className="text-left">Innborgun</th>
            <td className="text-right"><TextAmount value={result.currentSum.payments}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Innborgun kröfuhafi</th>
            <td className="text-right"><TextAmount value={result.currentSum.paymentsCreditor}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>}
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Innborgun lögmaður</th>
            <td className="text-right"><TextAmount value={result.currentSum.paymentsLawyer}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>}
            <tr className="text-bold">
            <th className="text-left">Samtals</th>
            <td className="text-right"><TextAmount value={result.currentSum.total}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Ofgreitt kröfuhafi</th>
            <td className="text-right"><TextAmount value={result.currentSum.paymentsCreditorOverPaid}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>}
            {showDetail && <tr className="status-calc-sub">
            <th className="text-left">-Ofgreitt lögmaður</th>
            <td className="text-right"><TextAmount value={result.currentSum.paymentsLawyerOverPaid}/></td>
            <td  className="text-right">&nbsp;</td>
            </tr>}
            <tr  className="text-bold">
            <th className="text-left">Ógj. eftirst. auk vaxta</th>
            <td className="text-right"><TextAmount value={result.currentSum.notCalledInRemainderWithInterest}/></td>
            <td className="text-right">&nbsp;</td>
            </tr>
            <tr  className="text-bold">
            <th className="text-left">Jöfnunarreik.eftirst.</th>
            <td className="text-right"><TextAmount value={result.currentSum.equalizationAccount}/></td>
            <td className="text-right">&nbsp;</td>
            </tr>
            </tbody>
        </table>
        </div>
    );
  
}

StatusList.propTypes = {
  data: PropTypes.object,
};



export default StatusList;
